module.exports = __webpack_public_path__ + "media/burial-document_2000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/burial-document_2000.jpg
// module id = 14
// module chunks = 0